import { compareValues } from "@sscs/utils";
export const sortRiskEvaluations = (riskEvaluations) => {
    const statusOrder = [
        "fail",
        "warning",
        "pass",
    ];
    return riskEvaluations.toSorted((first, second) => {
        if (first.status === second.status) {
            return compareValues(first.count, second.count, true);
        }
        else {
            return compareValues(statusOrder.indexOf(first.status), statusOrder.indexOf(second.status), false);
        }
    });
};
export const getRiskEvaluationsCounters = (riskEvaluations) => {
    const result = {
        totalRisksCount: 0,
        passCount: 0,
        warningCount: 0,
        failCount: 0,
    };
    riskEvaluations.forEach((riskEvaluation) => {
        result.totalRisksCount++;
        result[`${riskEvaluation.status}Count`]++;
    });
    return result;
};
export function normalizePercentageValue(riskEvaluationsCounters, totalEvaluatedPolicies) {
    if (!totalEvaluatedPolicies) {
        return {
            pass: 0,
            warning: 0,
            fail: 0,
        };
    }
    const finalPassCount = totalEvaluatedPolicies -
        riskEvaluationsCounters.totalRisksCount +
        riskEvaluationsCounters.passCount;
    const percentages = {
        pass: (finalPassCount / totalEvaluatedPolicies) * 100,
        warning: (riskEvaluationsCounters.warningCount / totalEvaluatedPolicies) * 100,
        fail: (riskEvaluationsCounters.failCount / totalEvaluatedPolicies) * 100,
    };
    const flooredPercentages = {
        pass: Math.floor(percentages.pass),
        warning: Math.floor(percentages.warning),
        fail: Math.floor(percentages.fail),
    };
    const flooredSum = Object.values(flooredPercentages).reduce((sum, value) => sum + value, 0);
    const remainder = 100 - flooredSum;
    if (!remainder) {
        return flooredPercentages;
    }
    const sortedByFraction = Object.entries(percentages)
        .map(([status, percentage]) => ({
        status,
        fraction: percentage - flooredPercentages[status],
    }))
        .sort((first, second) => compareValues(first.fraction, second.fraction, true));
    for (let index = 0; index < remainder; index++) {
        if (sortedByFraction[index]) {
            const { status } = sortedByFraction[index];
            flooredPercentages[status] = Math.ceil(percentages[status]);
        }
    }
    return flooredPercentages;
}
//# sourceMappingURL=utils.js.map